import {
  BOOTSTRAP_LOGIN_AUTOMATED,
  BOOTSTRAP_LOGIN_AUTOMATED_LOADED,
  BOOTSTRAP_LOGIN_AUTOMATED_ERROR
} from './constants';

export const bootstrapLoginAutomated = (data) => ({
  type: BOOTSTRAP_LOGIN_AUTOMATED,
  data
});

export const bootstrapLoginAutomatedLoaded = () => ({
  type: BOOTSTRAP_LOGIN_AUTOMATED_LOADED
});

export const bootstrapLoginAutomatedError = (error) => ({
  type: BOOTSTRAP_LOGIN_AUTOMATED_ERROR,
  error
});



// WEBPACK FOOTER //
// ./src/containers/LoginAutomatedPage/actions.js